module.exports = __webpack_public_path__ + "img/lesson-finish.74267d36.png";